import React, { useState } from 'react';
import './UserDropdown.scss';
import { classes } from '../../services/utils';
import ClickOutside from '../ClickOutside/ClickOutside';
import { Link } from 'react-router-dom';
import { routesURLs } from '../../Routes';
import { GlobalTypes, useGlobalState } from '../../contexts/global';
import { useQuery } from 'react-query';
import { ProfileType } from '../../services/types';
import { logout } from '../../moduls/auth';
import { getProfile } from '../../moduls/profile';

const UserDropdown: React.FC<{ className?: string }> = ({ className }) => {
    const { dispatch } = useGlobalState();
    const [open, setOpen] = useState(false);
    const { data: profile } = useQuery<ProfileType>('profile', getProfile, {
        staleTime: Infinity,
    });
    
    function changePasswordModal() {
        setOpen(false);
        dispatch({ type: GlobalTypes.ToggleModal, modal: 'ModalChangePassword' });
    }

    function changeParentPasswordModal() {
        setOpen(false);
        dispatch({ type: GlobalTypes.ToggleModal, modal: 'ModalChangeParentPassword' });
    }

    return (
        <ClickOutside onClick={() => setOpen(false)}>
            <div className={classes('user-dropdown flex items-center gap-4', { [className || '']: !!className, 'is-open': open })}>
                <button className="dropdown-button cursor-pointer hidden lg:flex font-myriad items-center justify-center text-white w-[185px] py-2 font-semibold text-base bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl transition-colors duration-200" onClick={() => setOpen(!open)}>
                    <img
                        className="me-2"
                        src="https://c.animaapp.com/mbyttqkuyMhIPB/img/material-symbols-light-person-rounded.svg"
                    />
                    {profile?.name}
                </button>
                <div className="user-dropdown-menu">
                    <ul className="is-pure-list">
                        <li>
                            <Link to={routesURLs.dashboard}>Moje kurzy</Link>
                        </li>
                        <li>
                            <Link to={routesURLs.overview}>Přehled</Link>
                        </li>
                        <li>
                            <Link to={routesURLs.profile}>Zobrazit profil</Link>
                        </li>
                        <li>
                            <Link to={routesURLs.profileEdit}>Nastavení</Link>
                        </li>
                        <li>
                            <button onClick={changePasswordModal}>Změna hesla</button>
                        </li>
                        {profile?.is_parent_password_set && (
                            <li>
                                <button onClick={changeParentPasswordModal}>Změna rodičovského hesla</button>
                            </li>
                        )}
                        <hr className="h-mx-175 h-my-05" />
                        <li>
                            <button onClick={logout} className="user-dropdown-light-button">
                                Odhlásit se
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </ClickOutside>
    );
};

export default UserDropdown;
